import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionTypes } from "../../../redux/notificationAlert";
import { toast , ToastContainer } from "react-toastify";

export function NotificationAlert() {
  const dispatch = useDispatch();
  let reducer_notification = useSelector(
    (state) => state.reducer_notificationAlert
  );
  const [flag, setflag] = useState(false);

  useEffect(() => {
    if (reducer_notification.status && !flag) {
      toast[reducer_notification.typeAlert](reducer_notification.textAlert, {
        position: toast.POSITION.BOTTOM_RIGHT,
        onClose: () => dispatch({ type: actionTypes.close }),
      });
    }
  }, [reducer_notification]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setflag(reducer_notification.flagExpire);
  }, [!reducer_notification.flagExpire]); //eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={true}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastClassName={"font"}
        style={{ zIndex: 10000000001 }}
      />
    </div>
  );
}
